export const REACT_QUERY_REQUEST_TYPE = 'x-rq-type';
export const REACT_QUERY_REQUEST_TYPE_HTTP = 'http';
export const REACT_QUERY_REQUEST_TYPE_GRAPHQL = 'graphql';
export const REACT_QUERY_STATISTICS = 'x-rq-statistics';

export const DEFAULT_STALE_PERIOD = 60_000; // 1 minute
